<template>
    <div>
        <v-dialog v-model="reviewexerciseformdialog" max-width="900px">
            <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mt-4 mb-3 ml-1" @click="newItem" v-on="on">+</v-btn>
            </template>
            <v-card>
                <v-card-title>
                    <span class="text-subtitle-1 mb-4">
                        {{ isEdit ? $t('pmreviewexercise.editreviewformselection') : $t('pmreviewexercise.reviewformselection') }}
                    </span>
                </v-card-title>
            <v-card-text>
              <v-container>
                    <v-row>
                        <v-col cols="12" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="$t('pmreviewexercise.appraisalgroup')"
                                type="text"
                                :items="valValueList"
                                hide-selected
                                v-model="formData.valvalueid"
                                @input="updateValue"
                                @change="changeValValueHandler(formData.valvalueid)"
                                dense
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('pmreviewexercise.appraisalgroupcode')"
                                type="text"
                                v-model="formData.valvaluecode"
                                dense
                                background-color="#ffeab2"
                                readonly
                                @input="updateValue"
                                class="v-input"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="$t('pmreviewexercise.reviewform')"
                                type="text"
                                :rules="[rules.required]"
                                :items="reviewFormList"
                                hide-selected
                                v-model="formData.pmreviewformid"
                                @input="updateValue"
                                @change="changeReviewFormHandler(formData.pmreviewformid)"
                                dense
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                 :label="$t('pmreviewexercise.reviewformcode')"
                                type="text"
                                v-model="formData.pmreviewformcode"
                                background-color="#ffeab2"
                                readonly
                                @input="updateValue"
                                dense
                                class="v-input"
                            ></v-text-field>
                        </v-col>
                    </v-row>
            </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="saveReviewExerciseForm">{{$t('button.save')}}</v-btn>
              <v-btn color="red darken-1" text @click="closeReviewExerciseForm">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> 

        <v-row class="mt-4 mb-2">
            <v-col cols="12" class="review-stats-label" style="display:flex;align-items:center;padding-top:8px;padding-bottom:8px;">
                {{$t('pmreviewexercise.reviewformtemplates')}}
            </v-col>
        </v-row>

        <div style="overflow-x: auto; width: 100%;">
        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            class="elavation-1"
:sort-by="['code']"
            style="width:100%"
        >
            <template v-slot:[`item.action`]="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="modifyItemHandler(item)"
                >
                    mdi-pen
                </v-icon>
                <v-icon
                    small
                    class="ml-3 mr-2"
                    @click="deleteItemHandler(item)"
                >
                    mdi-delete
                </v-icon>
            </template>

            <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
            </div>

        </v-data-table>
        </div>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            reviewexerciseformdialog: false,
            detailItem: this.parentObject.detailItem,
         
            formData: {
                pmreviewexerciseid : this.parentObject.pmreviewexerciseid,
                valvalueid : null,
                valvaluecode : null,
                pmreviewformid : null,
                pmreviewformcode : null,
                rectimestamp: null,
                updatedby: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            valValue: [],
            valValueList: [],
            reviewForm: [],
            reviewFormList: [],

            isEdit: false,

            //error msg and dialog, check for duplicates vars
            isErr: false,
            errMsg: '',
        }
    },

    methods: {
        newItem() {
            this.isExisting = false;
            this.modify = false;
            this.resetSelections();
        },
        loadValValue() {
            const vm = this;
            this.$store.dispatch('get', {url: "/groupp_grouppb_appraisal/all"})
            .then(function (res) {
                vm.valValue = res.data.rec;
        
                for (let i = 0; i < vm.valValue.length; i++) {
                    vm.valValueList.push({
                    text: vm.valValue[i].valuecode,
                    value: vm.valValue[i].valvalueid, 
                    });
                }
                })
            .catch(function (err) {
                vm.errMsg = err;
            });
        },

        changeValValueHandler(id) {
            let item = this.valValue.find(item => item.valvalueid == id);
            this.formData.valvaluecode = item.valuecode;
        },

        loadReviewForm() {
            const vm = this;
            this.$store.dispatch('get', {url: "/reviewform/active/all"})
            .then(function (res) {
                vm.reviewForm = res.data.rec;
        
                for (let i = 0; i < vm.reviewForm.length; i++) {
                    vm.reviewFormList.push({
                    text: vm.reviewForm[i].formcode,
                    value: vm.reviewForm[i].id,
                    });
                }

                })
            .catch(function (err) {
                vm.errMsg = err;
            });
        },

        changeReviewFormHandler(id) {
            let item = this.reviewForm.find(item => item.id == id);
            this.formData.pmreviewformcode = item.formcode;
        },

        modifyItemHandler(item) {
            this.isEdit = true;
            this.reviewexerciseformdialog = true;
            this.formData = {...this.formData, ...item};
        },

        deleteItemHandler(item) {
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                return false;
            }

            if (confirm( this.$t('pmreviewexercise.deletereviewformtemplate') )) {
                this.$store.dispatch('delete', {url: "/reviewexerciseform/" + item.id})
                .then(function () {
                    const index = vm.detailItem.findIndex(detail => detail.id === item.id);
                    if (index !== -1) {
                        vm.detailItem.splice(index, 1);
                    }
                })
                .catch(function (err) {
                    vm.errMsg = err;
                });
            }
        },

        saveReviewExerciseForm() {
            const vm = this;

            if (this.isEdit) {//Edit
                if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                    return false;
                }

                this.$store.dispatch('put', {url: "/reviewexerciseform/" + this.formData.id, payload: this.formData})
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;
                        if (Array.isArray(res.data.error)) {
                            vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                        } else {
                            vm.errMsg = res.data.error;
                        }
                    } else {
                        const index = this.detailItem.findIndex(item => item.id === this.formData.id);
                        if (index !== -1) {
                            this.detailItem.splice(index, 1, { ...this.formData });
                        }
                        this.reviewexerciseformdialog = false;
                        this.isEdit = false;
                        this.resetSelections();
                    }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                    console.log("err", err);
                });
            } else { //Add
                if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                    return false;
                }

                this.$store.dispatch('post', {url: "/reviewexerciseform/create", payload: this.formData})
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;
                        if (Array.isArray(res.data.error)) {
                            vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                        } else {
                            vm.errMsg = res.data.error;
                        }
                    } else {
                        this.detailItem.push(res.data.result);
                        this.reviewexerciseformdialog = false;
                        this.resetSelections();
                    }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                    console.log("err", err);
                });
            }
        },

        closeReviewExerciseForm() {
            this.reviewexerciseformdialog = false;
            this.isErr = false;
            this.isEdit = false;

            // reset the form fields
            this.resetSelections();
        },

        resetSelections() {
            this.formData = {
                pmreviewexerciseid : this.parentObject.pmreviewexerciseid,
                valvalueid : null,
                valvaluecode : null,
                pmreviewformid : null,
                pmreviewformcode : null,
                rectimestamp: null,
                updatedby: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            }
        },  
        
        updateValue() {
            this.$emit('input', {
                reviewcode: this.formData.reviewcode,
                valvalueid : this.formData.valvalueid,
                valvaluecode : this.formData.valvaluecode,
                pmreviewformid : this.formData.pmreviewformid,
                pmreviewformcode : this.formData.pmreviewformcode,
            });
        },
    },

    mounted() {
        this.loadValValue();
        this.loadReviewForm();
    }
}
</script>

<style>

.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button
{
-webkit-appearance: none;
margin: 0;
}
</style>